import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../core/demo-ui.service';
@Component({ selector: 'rv-footer', standalone: true, templateUrl: './footer.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class FooterComponent { readonly ui = inject(DemoUiService); }
